export const DRAG_TOGGLE_SUPPRESSION_DISTANCE = 8

/** Matches Tailwind's `sm` breakpoint. */
export const TAILWIND_SM_BREAKPOINT = 640

/** Matches Tailwind's `lg` breakpoint. */
export const TAILWIND_LG_BREAKPOINT = 1024
